const PLUGIN_SETTINGS_PANEL_DISCARD_MODAL = "plugin-settings-panel-discard-modal";
export {
  PLUGIN_SETTINGS_PANEL_DISCARD_MODAL
};
//# sourceMappingURL=consts.js.map
